import React from 'react';
import { styled } from '@glitz/react';
import FacetValueViewModel from 'Shared/Facet/FacetValueViewModel.type';
import OptionCard, { ColorOptionCard } from './OptionCard';
import FacetViewModel from 'Shared/Facet/FacetViewModel.type';
import PriceSlider from './PriceSlider';

const numberOfColumns = (filterId: string) => (filterId === 'size' || filterId === 'color_base_groups' ? 4 : 2);

const SectionWrap = styled.div({
  display: 'grid',
  columnGap: '8px',
  rowGap: '8px',
  padding: { xy: '1px' },
  overflow: 'hidden',
  marginTop: '24px'
});

const PriceWrap = styled.div({
  paddingTop: '24px'
})

const PriceHeading = styled.span({
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '100%',
  display: 'block',
  paddingBottom: '16px',
  textTransform: 'uppercase',
})

type PropType = {
  filter: FacetViewModel;
  subHeading?: string;
  onFilterValuesUpdated: (filterValues: FacetValueViewModel[], ticket: string) => void;
  onPriceUpdated: (filter: FacetViewModel, ticket: string) => void;
};

const FilterSection = ({ filter, subHeading, onFilterValuesUpdated, onPriceUpdated }: PropType) => {
  const templateColumns = '1fr '.repeat(numberOfColumns(filter.id));
  if (filter.id === 'price') {
    return (
      <PriceWrap>
        <PriceHeading>{subHeading}</PriceHeading>
        <PriceSlider
          filter={filter}
          updateValue={(filter) => {
            onPriceUpdated(filter, 'price');
          }}
        />
      </PriceWrap>
    );
  }

  if(filter.type === "CHECKBOX") {
    return (
      <></>
    );
  }

  return (
    <SectionWrap
      css={{
        gridTemplateColumns: templateColumns,
      }}
    >
      {filter?.values.map((filterValue) =>
        filter.id === 'color_base_groups' ? (
          <ColorOptionCard
            key={filterValue.id}
            value={filterValue}
            toggleSelected={() => {
              filterValue.selected = !filterValue.selected;
              onFilterValuesUpdated(filter.values, filterValue.ticket);
            }}
          />
        ) : (
          <OptionCard
            key={filterValue.id}
            value={filterValue}
            toggleSelected={() => {
              filterValue.selected = !filterValue.selected;
              onFilterValuesUpdated(filter.values, filterValue.ticket);
            }}
          />
        ),
      )}
    </SectionWrap>
  );
};

export default FilterSection;
